import { createReducer, on, Action } from '@ngrx/store';

import * as CompareProductsActions from './compare-products.action';
import { ProductDataForBar } from './compare-products.models';

export const COMPARE_PRODUCTS_FEATURE_KEY = 'compare-products';

export interface CompareProductState {
  productsDataForBar: ProductDataForBar[];
}

export interface CompareProductPartialState {
  readonly [COMPARE_PRODUCTS_FEATURE_KEY]: CompareProductState;
}

export const initialCompareProductState: CompareProductState = {
  productsDataForBar: [],
};

const reducer = createReducer(
  initialCompareProductState,
  on(CompareProductsActions.addProductDataForBar, (state, { productDataForBar }) => ({
    ...state,
    productsDataForBar: [...state.productsDataForBar, productDataForBar],
  })),
  on(CompareProductsActions.removeProductFromComparison, (state, { productId }) => ({
    ...state,
    productsDataForBar: state.productsDataForBar.filter(product => product.id !== productId),
  })),
  on(CompareProductsActions.removeAllProductsFromComparison, state => ({
    ...state,
    productsDataForBar: [],
  }))
);

export function compareProductsReducer(state: CompareProductState | undefined, action: Action): CompareProductState {
  return reducer(state, action);
}
